import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import PhilApp from './phil/PhilApp';

// The platform is unified under Phil with an in-app role switcher. The
// Administrator role surfaces the Priority Intelligence screens (formerly the
// standalone "FIL Portal"); Applicant and Evaluator have their own personas.
export default function App() {
  return (
    <BrowserRouter>
      <PhilApp />
    </BrowserRouter>
  );
}
